module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_02_Beatpad.66197495.png";